import React, {useReducer} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";

import {updateCanvasCount} from "../../../../../actions/actionFunctions";
import WithClickCount from "../../../hocs/withClickCount";
import {featureInterface} from "../../../../../interfaces/featureInterface";
import {SLAT_WALL_POSITIONS} from "../../../../commonVisualizer/core/constants";
// import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const GroheFeatureOptionsSlatWall = (props) => {

  const {lookActiveFeature, updateCanvasCount} = props;
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const featureGroup = lookActiveFeature.getParent();

  const optionsButtonClick = (position, maxClickCountReached) => {
    // const featureLabel = (Analytics.getStringForAnalytics(getValueText(option.metaValue))).toLowerCase() + "_" + Analytics.getSkuForAnalytics(lookActiveFeature);
    // const analyticsLabel = IS_PRODUCT_JOURNEY
    //   ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureOptions + featureLabel
    //   : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeatureOptions + featureLabel;
    // Analytics.sendClickEvent(analyticsLabel);

    if (maxClickCountReached()) { // fabricator settings click lead capture
      return false;
    }

    if (featureGroup.disabled) {
      featureGroup.disabled = false;
      featureGroup.disabledClick(); // disable also related parts
    }
    lookActiveFeature.handleClick(); // to apply not compatible and so on
    featureGroup.slatWallType = position;
    featureGroup.activeFeatureParts = featureGroup.setActiveFeatureParts();

    updateCanvasCount();
    forceUpdate();
  };

  return (
    <WithClickCount>
      {(maxClickCountReached) => (
        <div className="lk-feature__options">
          <span className="lk-feature__options-title">
            <FormattedMessage id="grohe.feature.placement"/>:
          </span>
          <div className="lk-feature__options-list">
            {SLAT_WALL_POSITIONS.map((position) => {
              const isActive = featureGroup.slatWallType === position;
              return (
                <Button className={"look-button look-button--half-radius look-button--option lk-type" + (isActive ? " look-button--option-active" : "")}
                        key={position}
                        onClick={() => optionsButtonClick(position, maxClickCountReached)}>
                  <FormattedMessage id={"visualizer.laundryRoom.slatWall." + position}/>
                </Button>
              )
            })}
          </div>
        </div>
      )}
    </WithClickCount>
  )
};

GroheFeatureOptionsSlatWall.propTypes = {
  activeFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store, ownProps) => {
  const {lookActiveFeature} = store.lookState;
  const {canvasCount} = store.bathroomVisualizerState;

  return {
    lookActiveFeature: ownProps.activeFeature || lookActiveFeature,
    canvasCount,
  };
};

const mapDispatchToProps = {
  updateCanvasCount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFeatureOptionsSlatWall)
)
